
import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import { readableColor } from 'polished';
import breakpoint from 'styled-components-breakpoint';
import PropTypes from 'prop-types';

const HamburgerEle = styled.div`
    display: none;
    justify-content: center;
    align-items: center;
    width: auto;
    cursor: pointer;
    vertical-align: middle;

    &.inactive {
        color: ${props => readableColor(props.theme.global.colors.sideBarColor)};
    }

    &.active, &:hover {
        color: ${props => props.theme.colors.lochmara};
    }

    ${breakpoint('xs', 'md')`
        display: flex;
    `}
`;

const ExpansionIcon = styled.i`
    font-size: 18px;
    margin-right: 15px;
    display: flex;
`;

class SidebarHamburger extends Component {
    render() {
        return (
            <HamburgerEle onClick={this.props.onClick} className={`${this.props.mobileNavExpanded ? 'active' : 'inactive'}`}>
                <ExpansionIcon key={1} className="icon-hamburger" />
            </HamburgerEle>
        );
    }
}

SidebarHamburger.propTypes = {
    mobileNavExpanded: PropTypes.bool,
    admin: PropTypes.bool,
    onClick: PropTypes.func
};

export default withTheme(SidebarHamburger);



// WEBPACK FOOTER //
// ./src/components/atoms/layout/SidebarHamburger.js